import { jsx as _jsx } from "react/jsx-runtime";
import { BaseEdge, getSmoothStepPath } from '@xyflow/react';
import { E_FLOW_HEX, HIGHLIGHT_HEX } from '../../../constants';
/**
 * Component renders "energy" type of connection of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_EDGE_TYPES.
 */
const RFEnergyEdgeFC = ({ sourceX, sourceY, targetX, targetY, selected, sourcePosition, targetPosition, style = {} }) => {
    const [edgePath] = getSmoothStepPath({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition,
        borderRadius: 0
    });
    return (_jsx(BaseEdge, { path: edgePath, style: { ...style, stroke: selected ? HIGHLIGHT_HEX : E_FLOW_HEX, strokeWidth: 2 } }));
};
export const RFEnergyEdge = RFEnergyEdgeFC;
//# sourceMappingURL=RFEnergyEdge.js.map